import { useSearchParams } from 'react-router-dom';

import { SearchListType } from 'core/components';
import { SearchPartBoms } from 'partBoms/components';
import { IPartBom } from 'partBoms/types';

import { RemovePartBomButton } from './RemovePartBomButton';

export const PartBomList = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const onSearchQuery = (query?: string) => {
    if (!query) {
      setSearchParams([]);

      return;
    }
    setSearchParams({ query });
  };

  const getPartCardButtons = (partBom: IPartBom) => {
    return [<RemovePartBomButton key="removePartBomButton" partBom={partBom} />];
  };

  return (
    <SearchPartBoms
      defaultQuery={searchParams.get('query')}
      onSearchQuery={onSearchQuery}
      getPartCardButtons={getPartCardButtons}
      type={SearchListType.FULL}
    />
  );
};
